var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg audit-home",style:({height:_vm.height+'px'})},[(_vm.show)?_c('router-view',{staticStyle:{"overflow-y":"auto","height":"100%"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }